var PostController = function() {
    this.ScrollMagic = require('ScrollMagic');
    this.getScrollScene = require('../module/getScrollScene');
    this.PostSlider = require('../module/PostSlider');
    this.InfiniteScroll = require('../module/InfiniteScroll');
    this.Parallax = require('../module/Parallax');
    this.PostBody = require('../module/PostBody');
    this.init();
};

PostController.prototype = {
    init: function() {
        var self = this;
        var swiperCount = 0;

        //scene controller
        var controller = new ScrollMagic();
        //scene option
        var headerOption = {
            triggerElement: '#js-mainvisual',
            triggerHook: 'onLeave',
            offset: $('#js-mainvisual').height(),
            reverse: true
        };

        var shareOptionIn = {
            triggerElement: '.l-content main:last-of-type .l-post-inner',
            triggerHook: 'onEnter',
            offset: $(window).height() - $('#js-globalHeader').height(),
            reverse: true
        }

        var shareOptionOut = {
            triggerElement: '.l-content main:last-of-type .related-article',
            triggerHook: 'onEnter',
            offset: $(window).height() - $('#js-globalHeader').height() - $('.post-share').height() - ($('.post-share').position().top * 2),
            reverse: true
        }

        var scrollScene = this.getScrollScene;
        require('../module/scene-globalHeader')(scrollScene(controller, headerOption));
        require('../module/scene-postShareIn')(scrollScene(controller, shareOptionIn));
        require('../module/scene-postShareOut')(scrollScene(controller, shareOptionOut));

        var postSlider = new self.PostSlider($('.swiper-container'));
        swiperCount++;

        self.PostBody();

        //infiniteScroll & Parallax
        var infiniteScroll = new this.InfiniteScroll();
        var parallax = new this.Parallax();
        var $window = $(window);
        var trigger;

        var scrollHandler = function(){
            if(trigger){
                clearTimeout(trigger);
            }
            trigger = setTimeout(function(){
                if(infiniteScroll.checkPosition()){
                    infiniteScroll.load(function() {
                        postSlider.reset($('.swiper-container'));
                        swiperCount++;
                        parallax.reset();
                        parallax.scroll();
                        self.PostBody();
                        require('../module/scene-postShareIn')(scrollScene(controller, shareOptionIn));
                        require('../module/scene-postShareOut')(scrollScene(controller, shareOptionOut));
                        $('.fb-like:first').clone().appendTo('.fb-like:last');
                    });
                }
            }, 200);
            parallax.scroll();
        }
        var resizeHandler = function(){
            parallax.reset();
            infiniteScroll.resize();
        }
        var loadHandler = function(){
            infiniteScroll.set($('.js-infinite-scroll'));
            parallax.init();
            parallax.scroll();
            $window.on('scroll', scrollHandler);
            $window.on('resize', resizeHandler);
        }
        $window.on('load', loadHandler);
    }
};

module.exports = PostController;



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/controller/PostController.js
 **/